import {Button} from '@mui/material'
import {useI18n} from 'i18n/I18nContext'
import React, {useState} from 'react'
import {toast} from 'react-toastify'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import styled from 'styled-components'

export const ZapierApiToken = (props: {token: string}) => {
  const {token} = props
  const {t} = useI18n()

  const [isVisible, setIsVisible] = useState(false)

  const copyToClipboard = () => {
    navigator.clipboard.writeText(token)
    toast.success(t('orgZapier.apiTokenCopied'))
  }

  return (
    <Wrapper>
      <h4>{t('orgZapier.apiTokenTitle')}</h4>
      <p>{t('orgZapier.apiTokenHelp')}</p>

      <Row>
        <TokenDisplay>
          {isVisible ? token : '•'.repeat(token.length)}
        </TokenDisplay>

        <IconButton
          onClick={() => setIsVisible(!isVisible)}
          title={
            isVisible
              ? t('orgZapier.apiTokenHide')
              : t('orgZapier.apiTokenShow')
          }
        >
          {isVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
        </IconButton>

        <IconButton
          onClick={copyToClipboard}
          title={t('orgZapier.apiTokenCopy')}
        >
          <ContentCopyIcon />
        </IconButton>
      </Row>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 15px;
`

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const TokenDisplay = styled.div`
  flex: 1;
  height: 48px;
  border: 1px solid var(--clr-border-4);
  border-radius: 4px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  background: var(--clr-bg-11);
  color: var(--clr-text-secondary);
  font-family: monospace;
  font-size: 15px;
  user-select: none;
  overflow: hidden;
`

const IconButton = styled(Button)`
  min-width: 42px !important;
  height: 48px;
  border-radius: 4px !important;
  color: var(--clr-text-secondary);
  border: 1px solid var(--clr-border-4);

  &:hover {
    border-color: var(--clr-border-7);
    background: var(--clr-bg-12);
  }

  svg {
    font-size: 20px;
  }
`
